import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from 'src/app/modules/directives/directives.module';
import { MedicalConditionIonItemComponent } from './medical-condition-ion-item/medical-condition-ion-item.component';
import { MedicalConditionsManagerComponent } from './medical-conditions-manager/medical-conditions-manager.component';
import { MedicalStatusConfigComponent } from './medical-status-config/medical-status-config.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    TranslateModule,
    DirectivesModule,
  ],
  declarations: [
    MedicalConditionIonItemComponent,
    MedicalConditionsManagerComponent,
    MedicalStatusConfigComponent,
  ],
  exports: [
    MedicalConditionIonItemComponent,
    MedicalConditionsManagerComponent,
    MedicalStatusConfigComponent,
  ],
})
export class MedicalConfigurationModule {}
